module.exports = "<!--The content below is only a placeholder and can be replaced.-->\n<loader *ngIf=\"loading\"></loader>\n<router-outlet></router-outlet>\n"